var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.125C12.0355 6.125 12.875 5.28553 12.875 4.25C12.875 3.21447 12.0355 2.375 11 2.375C9.96447 2.375 9.125 3.21447 9.125 4.25C9.125 5.28553 9.96447 6.125 11 6.125Z",
    fill: "#181B5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.875C12.0355 12.875 12.875 12.0355 12.875 11C12.875 9.96447 12.0355 9.125 11 9.125C9.96447 9.125 9.125 9.96447 9.125 11C9.125 12.0355 9.96447 12.875 11 12.875Z",
    fill: "#181B5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.625C12.0355 19.625 12.875 18.7855 12.875 17.75C12.875 16.7145 12.0355 15.875 11 15.875C9.96447 15.875 9.125 16.7145 9.125 17.75C9.125 18.7855 9.96447 19.625 11 19.625Z",
    fill: "#181B5E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTable);
export default __webpack_public_path__ + "static/media/infoTable.4aaa58bf2c15d66b0bd06e733d99244e.svg";
export { ForwardRef as ReactComponent };